var map = {
	"./close.png": 9642,
	"./db.png": 2018,
	"./fashi-1.png": 5947,
	"./fashi-mo.png": 4016,
	"./fashi-ren.png": 1985,
	"./fashi-t.png": 8854,
	"./fashi.png": 8001,
	"./icon-0.png": 7020,
	"./jinrigongkai-0.png": 6443,
	"./kuang.png": 3090,
	"./longqishi-1.png": 6890,
	"./longqishi-ren.png": 7188,
	"./longqishi-t.png": 1431,
	"./longqishi.png": 5588,
	"./mo-0.png": 995,
	"./mo-1.png": 4509,
	"./qishi-1.png": 8796,
	"./qishi-mo.png": 1301,
	"./qishi-ren.png": 6494,
	"./qishi-t.png": 9601,
	"./qishi.png": 2118,
	"./ren-0.png": 3446,
	"./ren-1.png": 383,
	"./yemanren-1.png": 3687,
	"./yemanren-mo.png": 3479,
	"./yemanren-ren.png": 7661,
	"./yemanren-t.png": 7261,
	"./yemanren.png": 9445,
	"./youxia-1.png": 1655,
	"./youxia-ren.png": 7485,
	"./youxia-t.png": 7610,
	"./youxia.png": 1877,
	"./zhanxingshi-1.png": 1023,
	"./zhanxingshi-mo.png": 9708,
	"./zhanxingshi-ren.png": 821,
	"./zhanxingshi-t.png": 8866,
	"./zhanxingshi.png": 1789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1791;